import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { GetActiveMembersInput } from '../../../domain/dtos/get-active-members-input'
import { GetActiveMembersOutput } from '../../../domain/dtos/get-active-members-output'
import { QueryKey } from '../../../domain/enums/query-key'
import { GetActiveMembers } from '../../../usecases/members/get-active-members'

export const useGetActiveMembers = (input: GetActiveMembersInput) => {
  const container = useContainer()

  return useQuery<GetActiveMembersOutput>(
    [QueryKey.getActiveMembers, input.pageSize, input.page, input.search, input.types, input.productId],
    ({ signal }) => new GetActiveMembers(container.get(HttpClient)).execute(input, signal),
    {
      retry: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  )
}
